export const forecastScreen = "/";
export const mapScreen = "/map";
export const settingsScreen = "/settings";
